export default "__VITE_ASSET__CqMQKWPI__"